import { createContext } from 'react';
import { DependenciesMap } from 'api/project';

export const GetAllTasksAndProjectsContext = createContext({
  fetchDependenciesMapFlag: false,
  setFetchDependenciesMapFlag: (_value: boolean) => {},
  dependenciesMap: {} as DependenciesMap,
});
